import React,{Component} from 'react';

import {Header} from '../header/Header';
import {Footer} from '../footer/Footer';

export class TenderNotice extends Component{

    render(){
        return(
            <>
            <Header></Header>
            <br/>
            <br/>
            <br/>
              <div className="container">
                <h3 className="text-center">Tender Notice</h3>
                <br/>
                <ul>
                   <li> <a href="#">Corrigendum Cliping English</a></li>
                   <li> <a href="#">Hardware and Software Support/Development ( Technical Proposal / Financial Proposal )</a></li>
                   <li> <a href="#">Hiring of Security Services and Installation of CCTV</a></li>
                   <li> <a href="#">SBD Computer Stationery 2018</a></li>
                   <li> <a href="#">SBD Computers and IT related Items 2018-2019</a></li>
                   <li> <a href="#">SBD HIRING OF FURNITURE 2018</a></li>
                   <li> <a href="#">SBD Hiring of Janitorial Services</a></li>
                   <li> <a href="#">SBD Printing of Priced Forms 2018</a></li>
                   <li> <a href="#">NIT 2018</a></li>
                   <li> <a href="#">Notice Redressal Committee new</a></li>
                   <li> <a href="#">PPlan18-19</a></li>
                   <li> <a href="#">Procurement Committee 2018-2019</a></li>
                   <li> <a href="#">Sindhi Clipping corrigendum</a></li>
                   <li> <a href="#">Urdu Clipping Corrigendum</a></li>
                </ul>
              </div>
            <br/>
            <br/>
            <br/>
            <br/>
            <Footer></Footer>
            </>
        )
    }
}